// --------------------------------------------------------------
// Created On: 2026-07-05
// Author: Dimitra Weinstein
//
// Last Modified: 2026-07-17
// Modified By: Dimitra Weinstein
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------
import React, { Fragment } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import styles from "./MessageBubble.module.scss";

// MessageBubble component for displaying chat messages from the AI agent and the user.
export default function MessageBubble(props: Props): Component {
  return (
    <Fragment>
      <div
        className={`small m-3 pt-3 rounded-3 text-wrap text-white text-left ${
          props.isUserMessage ? styles.userMessage : styles.agentMessage
        }`}
      >
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          components={{
            a: (props) => <a {...props} target="_blank" rel="noopener noreferrer" />,
          }}
        >
          {props.messageText}
        </ReactMarkdown>
      </div>
    </Fragment>
  );
}

interface Props {
  messageText: string;
  isUserMessage: boolean;
}
